Flup.link("relfont", function(flup, $elm, value){
   $elm.css("width", "100%");
   function changeFontSize(){
      value = value && Number(value) || 0.05;
      var maxLines = Number($elm.data("max-lines") || 0)
      var minLines = Number($elm.data("min-lines") || 0)
      var elWidth = $elm.outerWidth()
      var totalLines, fullElWidth

      var relFontsize = elWidth * value
      $elm[0].style.fontSize = relFontsize+'px'

      if(maxLines || minLines){
         $elm.css({"white-space": "nowrap", "width": "unset"});
         var maxLinesDone = maxLines == 0;
         var minLinesDone = minLines == 0;
         while(true){
            fullElWidth = $elm[0].offsetWidth
            totalLines = fullElWidth / elWidth
            if(!maxLinesDone){
               if(totalLines <= maxLines){
                  maxLinesDone = true;
               }else{
                  relFontsize -= .1;
                  $elm[0].style.fontSize = relFontsize+'px'
               }
            }
            if(!minLinesDone){
               if(totalLines >= minLines){
                  minLinesDone = true;
               }else{
                  relFontsize += .1;
                  $elm[0].style.fontSize = relFontsize+'px'
               }
            }
            if(maxLinesDone && minLinesDone) break;
         }
         $elm.css({"white-space": "", "width": "100%"});
      }
   }
   changeFontSize();
   $(window).resize(changeFontSize);
})